/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import AnswerText1 from 'material/embeds/content/shared/answer/text1/text1_container';
import AnswerText2 from 'material/embeds/content/shared/answer/text2/text2_container';
import AnswerImage1 from 'material/embeds/content/shared/answer/image1/image1_container';
import AnswerImage2 from 'material/embeds/content/shared/answer/image2/image2_container';
import AnswerEmoji from 'material/embeds/content/shared/answer/emoji/emoji_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/answer/answer_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER ~~~~~~~~~~ ========== */
class Answer extends Component {
	displayAnswerType() {
		switch(this.props.type) {
			case 'text1':
				return <AnswerText1 contentId={this.props.contentId} optionId={this.props.optionId} isEditable={this.props.isEditable} />;
            case 'text2':
                return <AnswerText2 contentId={this.props.contentId} optionId={this.props.optionId} isEditable={this.props.isEditable} />;
            case 'image1':
                return <AnswerImage1 contentId={this.props.contentId} optionId={this.props.optionId} isEditable={this.props.isEditable} />;
            case 'image2':
                return <AnswerImage2 contentId={this.props.contentId} optionId={this.props.optionId} isEditable={this.props.isEditable} />;
            case 'emoji':
            default:
                return <AnswerEmoji contentId={this.props.contentId} optionId={this.props.optionId} isEditable={this.props.isEditable} />;
		}
	}
    render() {
        return(
            <div className={`answer ${this.props.classes.answer}`}>
                {this.displayAnswerType()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Answer);
